import { Link } from 'react-router-dom';
import AboutPhara from './AboutPhara';
import WhyChoose from './WhyChoose';

const About = () => {


    return (
        <>
            <div className="abouttitle">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-lg-6">
                            <div className="page-tit">
                                <h1>About Us</h1>
                            </div>
                        </div>

                        <div className="col-md-12 col-lg-6">
                            <div className="breadcrumb-page">
                                <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li>About Us</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AboutPhara />
        </>
    )
}

export default About;